import React, { useContext, useEffect, useState } from "react";
import {
  useMatch,
  useNavigate,
  useParams,
  useResolvedPath,
} from "react-router-dom";
import { IconCheveron, IconCircle } from "../../../icons/Icon";
import { StoreContext } from "../../../store/StoreContext";
import NavItemTemplate from "./NavItemTemplate";
import _ from "lodash";
import { useCallback } from "react";

const SubNavItem = ({ item, addCurrentRoute }) => {
  const { category } = useParams();
  const resolved = useResolvedPath(item.path);
  const navigate = useNavigate();

  const { sidebarExpand, currentRoute, loadingSkirt } =
    useContext(StoreContext);

  const [expand, setExpand] = useState(false);

  const match = useMatch({ path: resolved.pathname, end: true });
  const active = Boolean(match) || category === String(item.id);
  const isChildren = item?.children?.length > 0;

  useEffect(() => {
    if (!sidebarExpand) {
      setExpand(false);
      return;
    }

    const route = _.find(currentRoute?.breadcrumbs, (r) => {
      return r.path === item.path;
    });
    setExpand(Boolean(route));
  }, [sidebarExpand]);

  const handleClick = useCallback(() => {
    if (loadingSkirt) return;

    if (isChildren) {
      setExpand((val) => !val);
    } else {
      addCurrentRoute(item);
    }
    navigate("skirt/" + item.id);
  }, [loadingSkirt]);

  return (
    <NavItemTemplate
      disabled={loadingSkirt}
      title={item.title}
      handleClick={handleClick}
      active={active}
      icon={<IconCircle color="#748A9D" />}
      buttonExpand={
        isChildren && (
          <span className="expand-button">
            <IconCheveron color="#33383F" />
          </span>
        )
      }
      menuItemMainClass="py-2"
    >
      {isChildren && (
        <div className={`menu-item-child ${expand ? "expand" : ""}`}>
          {item.children.map((child) => (
            <SubNavItem
              key={child.id}
              item={child}
              addCurrentRoute={addCurrentRoute}
            />
          ))}
        </div>
      )}
    </NavItemTemplate>
  );
};

export default SubNavItem;
